
import { useEffect, useRef, useContext } from 'react';
import { useApp, AppContext } from '@/context/AppContext';
import { useToast } from '@/hooks/use-toast';
import { Sparkles } from 'lucide-react';

export function PetUnlockNotifications() {
  const context = useContext(AppContext);
  
  // Return early if context is not available
  if (!context) {
    return null;
  }
  
  const { state, loading } = context;
  const { toast } = useToast();
  const previousPointsRef = useRef(state?.totalPoints || 0);

  useEffect(() => {
    if (loading || !state?.isAuthenticated || !state?.totalPoints) return;

    const previousPoints = previousPointsRef.current;
    const currentPoints = state.totalPoints;

    // Check if points increased and we have a pet collection
    if (currentPoints > previousPoints && state.petCollection) {
      // Simple milestone notifications for Habitica system
      const milestones = [50, 100, 200, 500, 1000, 2000, 5000];
      const newMilestones = milestones.filter(milestone => 
        currentPoints >= milestone && previousPoints < milestone
      );

      if (newMilestones.length > 0) {
        toast({
          title: "🎉 Milestone Reached!",
          description: (
            <div className="space-y-1">
              <p className="text-sm">Congratulations! You've reached {newMilestones[0]} total points!</p>
              <div className="flex items-center gap-2 text-sm">
                <Sparkles className="w-3 h-3 text-yellow-500" />
                <span>Keep completing activities to discover rare pets and mounts!</span>
              </div>
              <p className="text-xs text-muted-foreground mt-2">
                Check your Pet Collection tab for new drops and hatching opportunities!
              </p>
            </div>
          )
        });
      }
    }

    previousPointsRef.current = currentPoints;
  }, [state?.totalPoints, state?.petCollection, state?.isAuthenticated, loading, toast]);

  return null;
}
